const toggleClasses = (prefixes, tags) => {
  prefixes.forEach(prefix => {
    tags.className.split(' ').forEach(className => {
      if (className.includes(prefix)) {
        const match = className.replace(prefix, '');
        tags.classList.remove(`${prefix}${match}`);
      }
    });
  });
};

export default toggleClasses;
